import { render, staticRenderFns } from "./sign_platform.vue?vue&type=template&id=75f315b2&"
import script from "./sign_platform.vue?vue&type=script&lang=js&"
export * from "./sign_platform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports